import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ClientAssetTranscriptionMatchInfoFragment = { __typename?: 'ClientAssetTranscriptionMatch', id: string, transcriptionId: string, term: string };

export const ClientAssetTranscriptionMatchInfo = /*#__PURE__*/ gql`
    fragment ClientAssetTranscriptionMatchInfo on ClientAssetTranscriptionMatch {
  id @client
  transcriptionId @client
  term @client
}
    ` as unknown as DocumentNode<ClientAssetTranscriptionMatchInfoFragment, unknown>;

        

        
export const useClientAssetTranscriptionMatchInfoFragment = (
  input: string | Omit<UseFragmentOptions<ClientAssetTranscriptionMatchInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'ClientAssetTranscriptionMatch' } };
    return input;
  })();

  return useFragment<ClientAssetTranscriptionMatchInfoFragment>({
    fragment: ClientAssetTranscriptionMatchInfo,
    fragmentName: 'ClientAssetTranscriptionMatchInfo',
    ...options,
  });
};
  
        